<script setup lang="ts">
import type { Component } from 'vue'
import { RouterLink } from 'vue-router'

const properties = defineProps<{
  routeName: string
  icon: Component
  rootPath: string | null
  hideMobile: boolean | undefined
}>()

const titleKey = `main_menu.${properties.routeName}`
</script>

<template>
  <li
    class="text-center text-xs text-sage-500 md:text-sm lg:mx-8 lg:my-2 lg:text-white"
    :class="{ 'hidden lg:block': hideMobile }">
    <RouterLink
      :to="{ name: routeName, params: { locale: $i18n.locale } }"
      class="flex flex-col items-center justify-center lg:h-12 lg:flex-row lg:justify-start lg:rounded-xl lg:px-4 lg:align-middle"
      :class="{ 'router-link-active': rootPath && $route.path.includes(rootPath) }">
      <Suspense>
        <component :is="icon" class="lg:mr-4 h-[22px] lg:h-auto" />
      </Suspense>
      <span class="mt-2 lg:mt-0">{{ $t(titleKey) }}</span>
    </RouterLink>
  </li>
</template>

<style scoped>
.router-link-active {
  @apply text-blue-500;
}

@media screen and (min-width: 1024px) {
  .router-link-active {
    @apply bg-[rgba(226,_238,_238,_0.10)] text-white;
  }
}
</style>
